/* ar-brown App (C) 2021 arbrown.co.jp All rights reserved.
 *******************************************************************************
 * Program ID:  SalesRepresentativeList.js
 * $Revision:   Ver1.0
 * $Modtime:    $
 *******************************************************************************
 * Author      (作成／更新年月日、担当者)
 *  2024/11/27 Rayoo)niu : 新規作成
 *
 * Summary SalesRepresentativeList画面
 *
 * Instructions / Preconditions
 *  なし
 *
 *******************************************************************************
 */
// pages
import React, { useEffect, useState } from "react";
/*  GraphQL API Acess */
import API, { graphqlOperation } from "@aws-amplify/api";
import {
  listALLArSalesRepresentatives,
} from "../graphql/queries";
/*  AWS標準設定 with Login Auth. */
import Amplify,{Auth} from "aws-amplify";
import awsconfig from "../aws-exports";
Amplify.configure(awsconfig);
import { Container,Row,Col,InputGroup } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  fixedTop: {
    position: "sticky",
    top: 0,
    boxShadow: "0 -1px 0 0 white,0 3px 0 0 #804F29,0 3px 0 0 transparent",
    backgroundColor: "white",
    zIndex: 9,
  },
  textFieldSearch:{
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "transparent",
    border: "1px solid #707070",
    borderRadius: "6px",
    color: "black",
    width:"80%"
  },
  textlabelSearch:{
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "rgb(91,56,9)",
    border: "1px solid #707070",
    color: "white",
    fontWeight: "bold",
    fontSize: '14px',
    alignItems: 'center',
    justifyContent: 'center',
    width:"20%"
  }
}));
const customTotal = (from, to, size) => (
  <span
    style={{ marginLeft: "1em" }}
    className="react-bootstrap-table-pagination-total"
  >
    {size} の結果の {from} から {to} を表示しています
  </span>
);
const pageButtonRenderer = ({ page, onPageChange }) => {
  const handleClick = (e) => {
    e.preventDefault();
    onPageChange(page);
  };
  return (
    <button className="btn-secondary btn" type="button" key={page}>
      <li className="page-item">
        <a style={{ color: "white" }} href="#" onClick={handleClick}>
          {page}
        </a>
      </li>
    </button>
  );
};

const sizePerPageRenderer = ({
  options,
  currSizePerPage,
  onSizePerPageChange,
}) => (
  <div className="btn-group" role="group">
    {options.map((option) => (
      <button
        key={option.text}
        type="button"
        onClick={() => onSizePerPageChange(option.page)}
        className={`btn ${
          currSizePerPage === `${option.page}` ? "btn-warning" : "btn-light"
        }`}
      >
        {option.text}
      </button>
    ))}
  </div>
);
const options = {
  paginationSize: 10,
  pageStartIndex: 1,
  showTotal: true,
  withFirstAndLast: true,
  firstPageText: "最初",
  prePageText: "戻る",
  nextPageText: "次へ",
  lastPageText: "最後",
  nextPageTitle: "最初のページ",
  prePageTitle: "プレページ",
  firstPageTitle: "次のページ",
  lastPageTitle: "最後のページ",
  paginationTotalRenderer: customTotal,
  sizePerPageRenderer: sizePerPageRenderer,
  pageButtonRenderer: pageButtonRenderer,
  disablePageTitle: true,
  sizePerPageList: [
    {
      text: "10",
      value: 10,
    },
    {
      text: "20",
      value: 20,
    },
    {
      text: "30",
      value: 30,
    },
  ],
};

export const SalesRepresentativeList = () => {
  const [SalesRepresentativeList, setSalesRepresentativeList] = useState([]);
  const [progress, setProgress] = useState(false);
  const [OrderReceiptCodeList, setOrderReceiptCodeList] = useState([]);
  const [SalesGroupList, setSalesGroupList] = useState([]);
  const [ItemGroupList, setItemGroupList] = useState([]);
  const [SalespersonList, setSalespersonList] = useState([]);
  const [PlantList, setPlantList] = useState([]);
  const [SalespersonEmailList, setSalespersonEmailList] = useState([]);
  const classes = useStyles();
  const [searchValue, setSearchValue] = useState({
    OrderReceiptCode: "",
    SalesGroup:"",
    ItemGroup:"",
    Salesperson:"",
    Plant:"",
    SalespersonEmail:""
    })
  const searchValueChange = (e, value,name) => {
    if(name === "ItemGroup" || name === "SalespersonEmail"){
      setSearchValue({ ...searchValue, [name]: value ? value : "" })
    }else{
      setSearchValue({ ...searchValue, [name]: value ? value.split(":")[0] : "" })
    }
  }
 async function searchData() {
    let dataAll = [];
  try {
    const listInfo = await API.graphql(
      graphqlOperation(listALLArSalesRepresentatives)
    );
    console.log(listInfo);
    dataAll =
      listInfo.data.listALLArSalesRepresentatives["items"];
    let nextToken = listInfo.data.listALLArSalesRepresentatives.nextToken;
    while (nextToken !== null) {
      let InvDataSec = await API.graphql(
        graphqlOperation(listALLArSalesRepresentatives, {
          nextToken: nextToken,
        })
      );
      nextToken = InvDataSec.data.listALLArSalesRepresentatives.nextToken;
      for (
        let i = 0;
        i < InvDataSec.data.listALLArSalesRepresentatives.items.length;
        i++
      ) {
        dataAll.push(
          InvDataSec.data.listALLArSalesRepresentatives.items[i]
        );
      }
    }
} catch (err) {
  console.log(err);
}
  return dataAll
  }
  const searchBtn = async () => {
    setProgress(true)
    let arr = [];
    let dataAll = [];
    let obj = {};
    try {
      dataAll = await searchData()
      } catch (error) {
      console.log(error);
      }
      obj = searchValue;
      dataAll.forEach(item => {
        let flag = true
        if (Object.keys(obj).length !== 0) {
          for (let name in obj) {
            if (obj[name] !== "") {
              if (item[name]) {
                if (!(item[name]).includes(obj[name])) {
                  flag = false;
                  break;
                }
              } else {
                flag = false
                break;
              }
            }
          }
        }
        if (flag === true) {
          arr.push(item)
        }
      })
      arr = multiSort(arr,sortByOrderName)
      setSalesRepresentativeList(arr);
      setProgress(false)
  }
  const searchClear = async()=>{
      setProgress(true)
      let arr = [];
      try {
        arr = await searchData()
        } catch (error) {
          if (error.message === 'No current user') {
              //ユーザープールに障害が発生した場合
              console.log('User pool is invalid.Please reauthenticate.');
              //ログイン画面に戻る
              signOut();
          } else {
              //他のエラーを処理する
              console.log('An error occurred:', error);
          }
        }
        arr = multiSort(arr,sortByOrderName)
        setSearchValue({OrderReceiptCode: "",SalesGroup:"",ItemGroup:"",Salesperson:"",Plant:"",SalespersonEmail:""})
        setSalesRepresentativeList(arr);
        setProgress(false)
  }
const signOut = async () => {
    await Auth.signOut();
    try {
        await Auth.signOut();
    } catch (error) {
        console.log("error signing out: ", error);
    }
    document.location.reload();
  };
  const getTypePriority = (str) => {
    if (!str || str.trim() === "") return 99;
    const firstChar = str[0];
    if (/^[0-9]/.test(firstChar)) return 1;
    if (/^[a-zA-Z]/.test(firstChar)) return 2;
    if (/^[\u30A0-\u30FF]/.test(firstChar)) return 3;
    if (/^[\u3040-\u309F\u4E00-\u9FFF]/.test(firstChar)) return 4;
    return 5;
  };
  const sortByOrderName = (a, b) => {
    const nameA = a.OrderName || "";
    const nameB = b.OrderName || "";
    const priorityA = getTypePriority(nameA);
    const priorityB = getTypePriority(nameB);
    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }
    return nameA.localeCompare(nameB, 'ja', { sensitivity: 'base' });
  };
  const SortListFun = (arr)=>{
    arr.sort((a,b)=>{
     if (!a) {
         return 1;
       } else if (!b) {
         return 1;
       } else {
         return a.localeCompare(b)
       }
     })
     return arr
 }
  const multiSort = (arr, ...sortFuncs)=> {
    return arr.sort((a, b) => {
      for (const func of sortFuncs) {
        const result = func(a, b);
        if (result !== 0) {
          return result;
        }
      }
      return 0;
    });
  }
  const [scrollTableWidth,setscrollTableWidth] = useState('101%')
    function calculateZoomLevel() {
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const zoomLevel = ((windowWidth / screenWidth) + (windowHeight / screenHeight)) / 2;
      return Math.round(zoomLevel * 100);
    }
  useEffect(() => {
    let lastZoomLevel = calculateZoomLevel();
    async function getSalesRepresentativeList() {
      let SalesRepresentativeList = "";
      let listInfo = "";
      let orderReceiptCodeList = [];
      let salesGroupList = [];
      let itemGroupList = [];
      let salespersonList = [];
      let plantList = [];
      let salespersonEmailList = [];
      setProgress(true); // データのロード開始
      try {
        // 全ての情報を取得する
        listInfo = await API.graphql(
          graphqlOperation(listALLArSalesRepresentatives)
        );
        console.log(listInfo);
        SalesRepresentativeList =
          listInfo.data.listALLArSalesRepresentatives["items"];
        let nextToken = listInfo.data.listALLArSalesRepresentatives.nextToken;

        while (nextToken !== null) {
          let InvDataSec = await API.graphql(
            graphqlOperation(listALLArSalesRepresentatives, {
              nextToken: nextToken,
            })
          );
          nextToken = InvDataSec.data.listALLArSalesRepresentatives.nextToken;
          for (
            let i = 0;
            i < InvDataSec.data.listALLArSalesRepresentatives.items.length;
            i++
          ) {
            SalesRepresentativeList.push(
              InvDataSec.data.listALLArSalesRepresentatives.items[i]
            );
          }
        }
        for (let i = 0; i < SalesRepresentativeList.length; i++) {
          if (SalesRepresentativeList[i].OrderReceiptCode) {
            orderReceiptCodeList.push(SalesRepresentativeList[i].OrderReceiptCode + ":" + SalesRepresentativeList[i].OrderName)
            itemGroupList.push(SalesRepresentativeList[i].ItemGroup)
            salesGroupList.push(SalesRepresentativeList[i].SalesGroup + ":" + SalesRepresentativeList[i].SalesGroupName)
            salespersonList.push(SalesRepresentativeList[i].Salesperson + ":" + SalesRepresentativeList[i].SalespersonName)
            plantList.push(SalesRepresentativeList[i].Plant && SalesRepresentativeList[i].Plant + ":" + SalesRepresentativeList[i].PlantName)
            salespersonEmailList.push(SalesRepresentativeList[i].SalespersonEmail)
          }
        }
        SalesRepresentativeList = multiSort(SalesRepresentativeList,sortByOrderName)
        setOrderReceiptCodeList(Array.from(new Set(orderReceiptCodeList)))
        setItemGroupList(SortListFun(Array.from(new Set(itemGroupList))))
        setSalespersonList(SortListFun(Array.from(new Set(salespersonList))))
        setSalesGroupList(SortListFun(Array.from(new Set(salesGroupList))))
        setPlantList(SortListFun(Array.from(new Set(plantList))))
        setSalespersonEmailList(Array.from(new Set(salespersonEmailList)))
        setSalesRepresentativeList(SalesRepresentativeList);
        const handleResize = () => {
          let dom = document.querySelector("#table");
          const newZoomLevel = calculateZoomLevel();
          if (lastZoomLevel !== newZoomLevel) {
            if (newZoomLevel > lastZoomLevel) {
              setscrollTableWidth(dom ? `101%` : `101%`)
            }else {
              let width = dom ? (`${dom.offsetWidth}` < 1632 ? `1632px` : '101%') : '101%';
              setscrollTableWidth(`${width}`)
            }
            lastZoomLevel = newZoomLevel;
          }
        };
        window.addEventListener('resize',handleResize, 100);
        return () => window.removeEventListener('resize', handleResize);
      } catch (err) {
        console.error(err);
      } finally {
        setProgress(false); // ロードが終了したら進行状態を更新
      }
    }
    getSalesRepresentativeList();
  }, []);
  const headerStyle = {
    backgroundColor: "white",
    borderBottom: "3px solid #B45210",
  };
  let columns1 = [
    { dataField: "id", text: "ID", hidden: true },
    {
      dataField: "SalesGroup",
      text: "営業 Grp.",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "100px",minWidth:"100px" },
    },
    {
      dataField: "SalesGroupName",
      text: "営業グループ名称",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "160px",minWidth:"160px" },
    },
    {
      dataField: "OrderReceiptCode",
      text: "受注先",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "80px",minWidth:"100px" },
    },
    {
      dataField: "OrderName",
      text: "受注先名称",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "240px",minWidth:"100px" },
    },
    {
      dataField: "ItemGroup",
      text: "品目 Group",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "130px",minWidth:"130px" },
    },
    {
      dataField: "Plant",
      text: "プラント",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "100px",minWidth:"100px" },
    },
    {
      dataField: "PlantName",
      text: "プラント名",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "120px",minWidth:"120px" },
    },
    {
      dataField: "Salesperson",
      text: "営業員",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "100px",minWidth:"100px" },
    },
    {
      dataField: "SalespersonName",
      text: "営業員の名称",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "140px",minWidth:"140px" },
    },
    {
      dataField: "SalespersonEmail",
      text: "営業員メールアドレス",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "220px",minWidth:"220px" },
    },
  ];

  return (
    <Container
      style={{ backgroundColor: "", minWidth: "82vw", minHeight: "74vh" }}
    >
      <Row
        style={{
           borderRadius: "0.25em",
           color: "purple",
           padding: "0.5em",
            }}
          >
        <div style={{ display: 'flex', marginBottom: "10px",width:"100%"}}>
        <Col>
            <h4 style={{
               textAlign: "left",
               color: "black",
               height: 30,
               width: '20%',
               borderLeft: "4px solid #804F29",
               paddingLeft: "4px",
               whiteSpace:"nowrap"}}>
          営業担当者マスタ
        </h4>
        </Col>
        <div style={{ width: '80%',height: 194 }}>
               <div style={{ width: '90%',minWidth:'500px',height: 194, border: '2px solid rgb(191,191,191)', display: 'flex', flexWrap: "wrap",justifyContent:"center", padding: "30px 0px 0px 0px" }}>
               <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                         <InputGroup.Text
                            className={classes.textlabelSearch}
                            id="basic-name"
                            style={{ borderRadius: "0px",minWidth:"150px"}}
                          >営業 Grp.
                         </InputGroup.Text>
                         <Autocomplete
                             className={classes.textFieldSearch}
                              sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                              options={SalesGroupList}
                              value={searchValue.SalesGroup}
                              maxLength ="20"
                              onChange={(e, value) => { searchValueChange(e, value,"SalesGroup") }}
                              name="SalesGroup"
                              id="SalesGroup"
                              isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                             renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                         />
                      </InputGroup>
                  </div>
                  <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                         <InputGroup.Text
                             className={classes.textlabelSearch}
                             id="basic-name"
                             style={{ borderRadius: "0px",minWidth:"150px"}}
                         >受注先
                         </InputGroup.Text>
                           <Autocomplete
                            className={classes.textFieldSearch}
                            sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                            options={OrderReceiptCodeList}
                            value={searchValue.OrderReceiptCode}
                            name="OrderReceiptCode"
                            onChange={(e, value) => { searchValueChange(e, value,"OrderReceiptCode") }}
                            renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                            isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                        />
                       </InputGroup>
                  </div>
                  <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                         <InputGroup.Text
                            className={classes.textlabelSearch}
                            id="basic-name"
                            style={{ borderRadius: "0px",minWidth:"150px"}}
                          >品目 Group
                         </InputGroup.Text>
                         <Autocomplete
                             className={classes.textFieldSearch}
                              sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                              options={ItemGroupList}
                              value={searchValue.ItemGroup}
                              maxLength ="20"
                              onChange={(e, value) => { searchValueChange(e, value,"ItemGroup") }}
                              name="ItemGroup"
                              id="ItemGroup"
                              isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                             renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                         />
                      </InputGroup>
                  </div>
                  <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                         <InputGroup.Text
                            className={classes.textlabelSearch}
                            id="basic-name"
                            style={{ borderRadius: "0px",minWidth:"150px"}}
                          >プラント
                         </InputGroup.Text>
                         <Autocomplete
                             className={classes.textFieldSearch}
                              sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                              options={PlantList}
                              value={searchValue.Plant}
                              maxLength ="20"
                              onChange={(e, value) => { searchValueChange(e, value,"Plant") }}
                              name="Plant"
                              id="Plant"
                              isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                             renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                         />
                      </InputGroup>
                  </div>
                  <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                         <InputGroup.Text
                            className={classes.textlabelSearch}
                            id="basic-name"
                            style={{ borderRadius: "0px",minWidth:"150px"}}
                          >営業員
                         </InputGroup.Text>
                         <Autocomplete
                             className={classes.textFieldSearch}
                              sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                              options={SalespersonList}
                              value={searchValue.Salesperson}
                              maxLength ="20"
                              onChange={(e, value) => { searchValueChange(e, value,"Salesperson") }}
                              name="Salesperson"
                              id="Salesperson"
                              isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                             renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                         />
                      </InputGroup>
                  </div>
                  <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                         <InputGroup.Text
                            className={classes.textlabelSearch}
                            id="basic-name"
                            style={{ borderRadius: "0px",minWidth:"150px"}}
                          >営業員メールアドレス
                         </InputGroup.Text>
                         <Autocomplete
                             className={classes.textFieldSearch}
                              sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                              options={SalespersonEmailList}
                              value={searchValue.SalespersonEmail}
                              maxLength ="20"
                              onChange={(e, value) => { searchValueChange(e, value,"SalespersonEmail") }}
                              name="SalespersonEmail"
                              id="SalespersonEmail"
                              isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                             renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                         />
                      </InputGroup>
                  </div>
                  <div style={{margin:"auto"}}>
                    <Button className="btn" onClick={() => searchBtn()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: "3px solid black", background: "white",marginRight:'10px'}}>検索</Button>
                      <Button className="btn" onClick={() => searchClear()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: '3px solid black', background: "white"}}>Clear</Button>
                  </div>
               </div>
        </div>
        </div>
        </Row>
        <div
            style={{
              width: "100%",
              height: "100%",
              overflowX: "scroll",
              transform: "scaleY(-1)",
            }}
          >
            <div
              style={{
                width: scrollTableWidth,
                height: "65vh",
                overflowY: "scroll",
                overflowX: "hidden",
                transform: "scaleY(-1)",
              }}
            >
              <div style={{ direction: "ltr" }}>
        <BootstrapTable
          id="table"
          striped={true}
          hover={true}
          wrapperClasses="boo bg-white"
          bootstrap4
          keyField="id"
          data={SalesRepresentativeList}
          columns={columns1}
          noDataIndication={"no results found"}
          pagination={paginationFactory(options)}
          headerClasses={classes.fixedTop}
          />
        </div>
        </div>
        </div>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <CircularProgress
          size="3rem"
          disableShrink
          sx={{
            color: "#3f51b5",
            margin: "auto",
            display: progress ? "block" : "none",
            marginLeft: "60px",
          }}
        />
      </div>
    </Container>
  );
};

export default SalesRepresentativeList;
